import React, { useEffect, useState } from 'react';

const AddEditCategoryModal = ({ isOpen = true, category = null, onClose, onSubmit }) => {
  const [name, setName] = useState(category?.name || '');
  const [alwaysInclude, setAlwaysInclude] = useState(!!(category?.alwaysInclude || category?.always_include));

  useEffect(() => {
    setName(category?.name || '');
    setAlwaysInclude(!!(category?.alwaysInclude || category?.always_include));
  }, [category]);

  if (!isOpen) return null;

  const handleSubmit = () => {
    const payload = {
      id: category?.id,
      name: (name || '').trim() || 'Untitled',
      alwaysInclude: !!alwaysInclude,
    };
    onSubmit && onSubmit(payload);
  };

  const handleCancel = () => {
    setName('');
    setAlwaysInclude(false);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      {/* Backdrop with whitish blur */}
      <div 
        className="absolute inset-0 bg-white/40 backdrop-blur-md"
        onClick={handleCancel}
      />
      
      {/* Modal Card */}
      <div className="relative bg-white rounded-2xl border-[1.5px] border-primary-blue shadow-2xl w-full max-w-[25rem] 2xl:max-w-md">
        {/* Header with centered title */}
        <div className="relative px-8 pt-6 pb-5">
          <h2 className="text-xl font-semibold text-gray-900 text-center">
            {category ? 'Edit Segment' : 'Add Segment'}
          </h2>
          <button
            onClick={handleCancel}
            className="absolute right-6 top-6 hover:opacity-70 transition-opacity"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#9CA3AF" strokeWidth="2" fill="none"/>
              <path d="M8 8L16 16M16 8L8 16" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {/* Form Fields */}
        <div className="px-8 pb-6 pt-2 space-y-4">
          {/* Name Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Write here"
              className="w-full px-4 py-3 border-[1.5px] border-primary-blue rounded-lg focus:outline-none focus:ring-primary-blue focus:ring-1 transition-colors text-sm"
            />
          </div>

          {/* Include in Every Bid Dropdown */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Include in Every Bid?
            </label>
            <div className="relative">
              <select
                value={alwaysInclude ? 'yes' : 'no'}
                onChange={(e) => setAlwaysInclude(e.target.value === 'yes')}
                className="w-full px-4 py-3 border-[1.5px] border-primary-blue rounded-lg focus:outline-none focus:ring-primary-blue focus:ring-1 transition-colors appearance-none bg-white text-sm cursor-pointer"
              >
                <option value="no">Select</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
              {/* Custom Dropdown Arrow */}
              <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="px-8 pb-6 pt-2 flex gap-3">
          <button
            onClick={handleSubmit}
            className="flex-1 py-2.5 bg-primary-blue text-white font-semibold rounded-lg hover:bg-primary-blue/70 transition-colors text-base"
          >
            Submit
          </button>
          <button
            onClick={handleCancel}
            className="flex-1 py-2.5 bg-white border-[1.5px] border-primary-blue text-primary-blue font-semibold rounded-lg hover:bg-primary-blue hover:text-white transition-colors text-base"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddEditCategoryModal;
